import { Outlet, useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { AllEmployeeGroupsDocument } from 'generated/resources/graphql'

import EmptyList from 'modules/core/components/EmptyList'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import Employees from 'modules/settings/components/Payroll/LegalEntity/Employees'

const EmployeeGroupsRootPage = () => {
  const { legalEntity, onViewActivity } = useOutletContext<{
    legalEntity: LegalEntity
    onViewActivity: () => void
  }>()
  const { navigation } = useNavigation()
  const {
    data: employeeGroupsData,
    loading,
    error,
  } = useQuery(AllEmployeeGroupsDocument, {
    variables: {
      legalEntityIds: [legalEntity.id],
    },
  })
  const employeeGroups = employeeGroupsData?.employees.employeeGroups ?? []

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      widget={
        <Button.Router
          to={navigation.settings.legalEntitiesId.employeeGroups.new.fullPath({
            id: legalEntity.id,
          })}
          iconName="add"
          extra={{ 'data-intercom-target': 'settings-employee-group-add' }}
        >
          {i18n.t('settings.legal_entities.legal_entity.employee_group.add')}
        </Button.Router>
      }
      onActionClick={(key) => {
        if (key === 'view-activity') onViewActivity()
      }}
    >
      {!employeeGroups.length ? (
        <EmptyList
          description={i18n.t('settings.legal_entities.legal_entity.no_employees_groups')}
        />
      ) : (
        <Employees legalEntity={legalEntity} employeeGroups={employeeGroups} />
      )}
      <Outlet context={{ legalEntity }} />
    </ResponsivePage.Body>
  )
}

export default EmployeeGroupsRootPage
